import { OwLabel } from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import OwRadioSelect from "@components/shared/OwRadioSelect/OwRadioSelect";
import OwInputWrapper from "@components/shared/OwInputWrapper/OwInputWrapper";
import ICatalog_Item_Option from "@models/ICatalog_Item_Option";
import IItem_Option from "@models/IItem_Option";
import INewOrder_Item_Option from "@models/INewOrder_Item_Option";
import { IOption } from "@models/IOption";
import ISelectedItemOption from "@models/ISelectedItemOption";
import { useState } from "react";

type Props = {
    option: ICatalog_Item_Option;
    selectedItemOptionFn: (options: Partial<INewOrder_Item_Option>) => void;
};

export const OrderItemOption = (props: Props) => {
    const type = props.option.Item_Option?.type;
    const name = props.option.Item_Option?.name || "";
    const required = props.option.Item_Option?.required;

    const [checkboxActive, setCheckboxActive] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const selectOptionFn = (option: { value: string; title: string }) => {
        // console.log(option);

        const newOrderItemOption: Partial<INewOrder_Item_Option> = {
            item_option_id: props.option.item_option_id,
            value: option.value,
        };

        console.log("OrderItemOption", newOrderItemOption);

        props.selectedItemOptionFn(newOrderItemOption);
    };

    const handleCheckboxChange = () => {
        const newValue = !checkboxActive;
        setCheckboxActive(newValue);

        const newOrderItemOption: Partial<INewOrder_Item_Option> = {
            item_option_id: props.option.item_option_id,
            value: newValue ? "true" : "false",
        };

        props.selectedItemOptionFn(newOrderItemOption);
    };

    const handleRadioChange = (e: any) => {
        const newOrderItemOption: Partial<INewOrder_Item_Option> = {
            item_option_id: props.option.item_option_id,
            value: e.target.value,
        };

        props.selectedItemOptionFn(newOrderItemOption);
    };

    const handleInputChange = (e: any) => {
        const value = e.target.value;
        setInputValue(value);

        const newOrderItemOption: Partial<INewOrder_Item_Option> = {
            item_option_id: props.option.item_option_id,
            value: value,
        };

        props.selectedItemOptionFn(newOrderItemOption);
    };

    return (
        <div className={"OrderItemOption"}>
            <OwLabel title={name} skipTranslate={true} />
            {type === "dropdown" && (
                <div>
                    <OwSelectOption
                        options={props.option.Item_Option?.options || []}
                        valueProp={"value"}
                        titleProp={"title"}
                        fn={selectOptionFn}
                        name={name}
                        sizeClass="reg"
                        isRequired={required}
                        emitObject={true}
                    />
                </div>
            )}
            {type === "radio" && (
                <div>
                    <OwRadioSelect
                        options={(props.option.Item_Option?.options || []).map((opt) => ({
                            value: opt.value,
                            label: opt.title,
                        }))}
                        name={name}
                        fn={handleRadioChange}
                    />
                </div>
            )}
            {type === "checkbox" && (
                <div>
                    <OwToggle name={name} label="" active={checkboxActive} fn={handleCheckboxChange} disableTranslation={true} />
                </div>
            )}
            {type === "text" && (
                <div>
                    <OwInputWrapper name={name} type="text" value={inputValue} fn={handleInputChange} isRequired={required} />
                </div>
            )}
            {type === "number" && (
                <div>
                    <OwInputWrapper name={name} type="number" value={inputValue} fn={handleInputChange} isRequired={required} />
                </div>
            )}
        </div>
    );
};
